import Proptypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import { Button, ColorPickerInputGroup } from 'twyne-new.ui'

import { useBubbleTiptap } from '../bubble/Bubble';
import DropDown from './DropDown';

const propTypes = {
  onClick: Proptypes.func,
  icon: Proptypes.any,
  id: Proptypes.any,
  tooltipText: Proptypes.string,
  style: Proptypes.object,
}

export default function ColorFormatter({ onClick, onReset, icon: Icon, id, tooltipText, style }) {
  const [color, setColor] = useState()
  const [toggle, setToggle] = useState(false)
  const { setBubblePopover } = useBubbleTiptap()

  useEffect(() => {
    setBubblePopover && setBubblePopover(toggle)
  }, [toggle, setBubblePopover])

  const handleToggle = open => open && setToggle(true)

  const handleReset = useCallback(() => {
    onReset()
    setToggle(false)
  }, [onReset])

  const handleApply = () => {
    onClick(color.rgbaParsed)
    setToggle(false)
  }

  return (
    <DropDown
      small
      id={id}
      icon={Icon}
      direction="up"
      style={style}
      tooltipText={tooltipText}
      open={toggle}
      onOpenChange={handleToggle}
      contentProps={{ onInteractOutside: () => setToggle(false) }}>
      <div className="p-0 flex flex-col gap-2">
        <ColorPickerInputGroup
          value={color}
          onChange={setColor}
          components={['picker']}
        />
        <div className="flex gap-2">
          <Button className="w-1/2 block" size="sm" variant="outline" onClick={handleReset}>Reset</Button>
          <Button className="w-1/2 block" size="sm" color="accent" onClick={handleApply}>Apply</Button>
        </div>
      </div>
    </DropDown>
  )
}

ColorFormatter.propTypes = propTypes
ColorFormatter.defaultProps = {}
